import axios from 'axios'
const api = axios

const store = {
    actions:{
        getAllEventos: async ({}, data:any)=> {
            try{
                const response = await api.get('/Eventos/month/'+data.month+'/year/'+data.year)
                return response
            }catch(error){
                return error.response
            }
        },
        getCurrentTime: async ({},data: any)=>{
            try{
                return await api.get('/Eventos/currentTime')
            }catch(error){
                return error.response
            }
        },
        getStartConfiguration : async ({},data: any ) =>  {
            try{
                return await api.get('/Eventos/dateStartOperations')
            }catch(error){
                return error.response
            }
        },
        createEvento : async({},data:any)=>{
            try{
                return await api.post('/Eventos',data)
            }catch(error){
                return error.response
            }
        }
    }
}
export default store